import { z } from 'zod';

const authorizationTokenResponsePayloadSchema = z.object({
    'custom:is_service': z.string().optional(),
    'custom:roles': z.string(),
    'custom:talent_id': z.string(),
    'custom:tenant_id': z.string(),
});

export type AuthorizationTokenResponsePayload = z.infer<typeof authorizationTokenResponsePayloadSchema>;

export const authorizationTokenDecodedTransformedSchema = authorizationTokenResponsePayloadSchema.transform((data) => ({
    isService: data['custom:is_service'] === 'true',
    roles: z.string().array().parse(JSON.parse(data['custom:roles'])),
    tenantId: data['custom:tenant_id'],
    userId: data['custom:talent_id'],
}));

export type AuthorizationTokenTransformed = z.infer<typeof authorizationTokenDecodedTransformedSchema>;
